// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__3qwz0","col":"CardReaderDesc_col__2HMxl","label":"CardReaderDesc_label__171X8"};